export enum EquipmentTypeWithoutVRI {
  anpr = 'anpr',
  bluetooth = 'bluetooth',
  fcd = 'fcd',
  infrarood = 'infrarood',
  laser = 'laser',
  lus = 'lus',
  microwave = 'microwave',
  radar = 'radar',
  telslang = 'telslang',
  videodetectie = 'videodetectie',
  datafusie = 'datafusie',
  overig = 'overig'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/equipmenttypeWithoutVRI.ts